import React from 'react';
import './accordion.scss';
import {Icons} from "../Icons/Icons";

export interface AccordionHeaderProps {
    children: any;
    onClick: any;
}

const AccordionHeader = ({children, onClick}: AccordionHeaderProps) => {
    return (
        <div className={'accordion__header'} onClick={() => onClick()}>
            {children}
            <Icons />
            <svg viewBox="0 0 17 10" className="icon icon--arrow-standard">
                <use xlinkHref={'#arrow-standard'} />
            </svg>
        </div>
    )
}

export default AccordionHeader;
